import React from 'react';
//import { useNavigate } from "react-router-dom";


import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp,
} from '../../services/AuthService';


export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';



export function signupAction(email, password, navigate) {
	
    return (dispatch) => {
        signUp(email, password)
        .then((response) => {
            saveTokenInLocalStorage(response.data);
            runLogoutTimer(
                dispatch,
                response.data.expiresIn * 1000,
                //history,
            );
            dispatch(confirmedSignupAction(response.data));
            navigate('/admin/dashboard');
			//history.push('/dashboard');
        })
        .catch((error) => {
            const errorMessage = formatError(error.response.data);
            dispatch(signupFailedAction(errorMessage));
        });
    };
}

export function Logout(navigate) {
    // Nettoyer toutes les données d'authentification du localStorage
    console.log('Logout - Nettoyage complet du localStorage');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('persist:root');
    localStorage.removeItem('persist:auth');
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('selectedPlan');
    
    // Nettoyer aussi le sessionStorage
    sessionStorage.clear();
    
    navigate('/login');
	//history.push('/login');
    
    return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(email, password, navigate, redirectTo = '') {
    return (dispatch) => {
         console.log('[AuthActions] loginAction dispatched with', { email });
         login(email, password)
            .then((response) => { 
                console.log('[AuthActions] loginAction success:', response?.status);
                // Extract fields from backend response shape
                const data = response?.data || {};
                const extra = data?.extra || {};
                const user = data?.result || {};
                const tokenDetails = {
                    token: extra.authToken || '',
                    tokenType: extra.tokenType || 'Bearer',
                    email: user.email || data.email || email,
                    user,
                    // default to 24h if backend doesn't provide expiresIn
                    expiresIn: Number(data.expiresIn || data.expires_in || 24 * 60 * 60),
                };
                saveTokenInLocalStorage(tokenDetails);
                runLogoutTimer(
                    dispatch,
                    tokenDetails.expiresIn * 1000,
                    navigate,
                );
               dispatch(loginConfirmedAction(tokenDetails));
               
               // Déterminer la redirection selon le type d'utilisateur
               console.log('=== LOGIN DEBUG ===');
               console.log('User data:', user);
               console.log('Extra data:', extra);
               console.log('user_type_id:', user?.user_type_id);
               console.log('isAdmin:', extra?.isAdmin);
               
               let dashboardRoute = '/admin/dashboard'; // Par défaut admin
               
               if (extra && extra.isAdmin === true) {
                   // Admin
                   console.log('Detected: ADMIN user');
                   dashboardRoute = '/admin/dashboard';
               } else if (user && user.user_type_id === 2) {
                   // Consultant
                   console.log('Detected: CONSULTANT user');
                   dashboardRoute = '/consultant/dashboard';
               } else if (user && user.user_type_id === 1 && (!extra || extra.isAdmin === false)) {
                   // Entreprise
                   console.log('Detected: ENTREPRISE user');
                   dashboardRoute = '/entreprise/dashboard';
               } else {
                   console.log('Detected: DEFAULT (unknown user type)');
               }
               
               console.log('Final redirect route:', dashboardRoute);
               console.log('Navigating now...');
               const safeRedirect = typeof redirectTo === 'string' ? redirectTo.trim() : '';
               if (safeRedirect && safeRedirect.startsWith('/')) {
                   navigate(safeRedirect);
               } else {
                   navigate(dashboardRoute);
               }
            })
            .catch((error) => {
				//console.log('error');
				//console.log(error);
                const errorMessage = formatError(error?.response?.data || error?.message || 'Authentication failed');
                dispatch(loginFailedAction(errorMessage));
            });
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}

